<template>
  <div>
    <b-row>
      <b-col cols="12" md="8">
        <b-form>
          <b-row>
            <b-col
              v-for="(col, index) in userColsTop"
              :key="col.field || index"
              md="6"
            >
              <validation-observer :ref="`simpleRules${col.field}`">
                <validation-provider
                  #default="{ errors }"
                  :name="col.label"
                  :rules="col.formOption ? col.formOption.rules : ''"
                >
                  <form-item
                    :required="col.required"
                    :only-show="col.onlyShow"
                    :form-label="col.label"
                    :form-value="setValue(col)"
                    @saveFormItem="
                      update($event, userData[col.field], col.field)
                    "
                    @clearFormItem="clearFormItem"
                  >
                    <template slot="labelSmall">
                      <small class="text-danger">{{ errors[0] }}</small>
                    </template>
                    <element-component
                      :id="`v-add-${col.field}`"
                      v-model="userData[col.field]"
                      :state="errors.length > 0 ? false : null"
                      :label="col.label"
                      :option="col"
                    />
                  </form-item>
                </validation-provider>
              </validation-observer>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
      <b-col cols="12" md="4">
        <c-upload
          v-model="userData.photoType"
          :limit="1"
          @change="updatePhoto"
        />
      </b-col>
    </b-row>
    <hr class="invoice-spacing" />
    <b-form>
      <b-row>
        <b-col
          v-for="(col, index) in userColsBottom"
          :key="col.field || index"
          cols="12"
          md="4"
        >
          <validation-observer :ref="`simpleRules${col.field}`">
            <validation-provider
              #default="{ errors }"
              :name="col.label"
              :rules="col.formOption ? col.formOption.rules : ''"
            >
              <div
                v-if="col.disabled"
                style="padding-left:15px;display:inline-block;"
              >
                <label :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                ><br />
                <small class="text-primary">{{ col.small }}</small>
              </div>
              <form-item
                v-else
                :required="col.required"
                :only-show="col.onlyShow"
                :form-label="col.label"
                :form-value="setValue(col)"
                @saveFormItem="update($event, userData[col.field], col.field)"
                @clearFormItem="clearFormItem(col.field)"
                @changeEdit="changeEdit(col.field)"
              >
                <template slot="labelSmall">
                  <small class="text-danger">{{ errors[0] }}</small>
                </template>
                <div v-if="col.field === 'mobile'" style="height: 39px;">
                  <el-input
                    placeholder="Mobile"
                    v-model="userData.mobile"
                    type="number"
                  >
                    <el-select
                      style="width: 90px"
                      v-model="userData.mobileCode"
                      slot="prepend"
                      filterable
                      :filter-method="customFilter"
                    >
                      <el-option
                        v-for="country in filteredCountries"
                        :key="country.code"
                        :label="country.nameLabel"
                        :value="country.zone"
                      >
                      </el-option>
                    </el-select>
                  </el-input>
                </div>
                <element-component
                  v-else
                  :id="`v-add-${col.field}`"
                  v-model="userData[col.field]"
                  :state="errors.length > 0 ? false : null"
                  :label="col.label"
                  :option="col"
                  :disabled="col.disabled"
                />
              </form-item>
            </validation-provider>
          </validation-observer>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import WORKER from '@/api/worker/index'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FormItem from '@/components/FormItem.vue'
import ElementComponent from '@/components/elementComponent.vue'
import CUpload from '@/components/upload/index.vue'
import { BCol, BRow, BForm, BAvatar } from 'bootstrap-vue'
import { deepClone } from '@/util/util'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Success } from '@icon-park/vue/es/map'
import countryCode from '@/util/mobileCode'
function getAge(birthday) {
  const date = new Date()
  const today = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  const age = today.map((value, index) => value - birthday[index])
  // 当天数为负数时，月减 1，天数加上月总天数
  if (age[2] < 0) {
    const lastMonth = new Date(today[0], today[1], 0)
    age[1] -= 1
    age[2] += lastMonth.getDate()
  }
  // 当月数为负数时，年减 1，月数加上 12
  if (age[1] < 0) {
    age[0] -= 1
    age[1] += 12
  }
  return age[0]
}
export default {
  components: {
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    FormItem,
    BForm,
    BRow,
    BCol,
    CUpload,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    refreshChange: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      userData: { mobileCode: '' },
      userDataCopy: { mobileCode: '' },
      countries: [],
      filteredCountries: [],
      hasToStringTypes: ['select'],
    }
  },
  mounted() {
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
  },
  computed: {
    userColsTop() {
      const userInfoList = [
        {
          label: this.i18n('label.name'),
          field: 'name',
          searchSpan: 2,
          searchBase: true,
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.cnName'),
          field: 'cnName',
          searchSpan: 2,
          searchBase: true,
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.nric'),
          field: 'nric',
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          // label: this.i18n('label.nric'),
          label: 'Age',
          field: 'age',
          onlyShow: true,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.nationality'),
          field: 'nationality',
          type: 'select',
          // dictBizCode: 'nationality',
          dictCode: 'nationality',
          dicName: 'nationalityName',
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.sex'),
          field: 'sex',
          type: 'select',
          searchSpan: 2,
          dictBizCode: 'gender',
          // dictBizCode: 'getSchemeList',
          dicName: 'sexName',
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.birthday'),
          field: 'birthday',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.employmentCategory'),
          field: 'employmentCategory',
          type: 'select',
          dictBizCode: 'worker_employment_category',
          dicName: 'employmentCategoryName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('labelEmployment.status'),
          field: 'status',
          type: 'select',
          dictBizCode: 'info_status',
          dicName: 'statusName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.projectId'),
          field: 'projectId',
          type: 'select',
          dictCode: 'project',
          dicName: 'projectName',
          formOption: {
            rules: 'required',
          },
          disabled: true,
          onlyShow: true,
        },
      ]
      return userInfoList
    },
    userColsBottom() {
      const userInfoList = [
        {
          label: this.i18n('label.employmentCode'),
          field: 'employmentCode',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.maritalStatus'),
          field: 'maritalStatus',
          type: 'select',
          dictBizCode: 'staff_marital_status',
          dicName: 'maritalStatusName',
          onlyShow: this.detailType === 'view',
        },
        {
          // label: this.i18n('label.employmentCode'),
          label: 'Foreign ID',
          field: 'foreignId',
          onlyShow: this.detailType === 'view',
        },
        {
          // label: this.i18n('label.employmentCode'),
          label: 'Permit Type',
          field: 'permitType',
          type: 'select',
          dictBizCode: 'worker_permit_type',
          dicName: 'permitTypeName',
          onlyShow: this.detailType === 'view',
        },
        {
          // label: this.i18n('label.employmentCode'),
          label: 'Levy',
          field: 'levy',
          onlyShow: this.detailType === 'view',
        },
        {
          // label: this.i18n('label.employmentCode'),
          label: 'FIN NO',
          field: 'finNo',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.cardNo'),
          field: 'cardNo',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.mobile'),
          field: 'mobile',
          hide: true,
          required: true,
          formOption: {
            rules: 'required',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.passportExpiryDate'),
          field: 'passportExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          required: true,
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.passportNumber'),
          field: 'passportNumber',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.address'),
          field: 'address',
          onlyShow: this.detailType === 'view',
          // span: 8,
        },
        {
          label: this.i18n('label.personalEmail'),
          field: 'personalEmail',
          required: true,
          formOption: {
            rules: 'required|email',
          },
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.vaccinationStatus'),
          field: 'vaccinationStatus',
          dicName: 'vaccinationStatusName',
          type: 'select',
          dictBizCode: 'vaccination_status',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.religion'),
          field: 'religion',
          dicName: 'religionName',
          type: 'select',
          dictBizCode: 'religion',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.race'),
          field: 'race',
          dicName: 'raceName',
          type: 'select',
          dictBizCode: 'race',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.idType'),
          field: 'idType',
          dicName: 'idTypeName',
          type: 'select',
          dictBizCode: 'id_type',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.chinaCode'),
          field: 'chinaCode',
          dicName: 'chinaCodeName',
          type: 'select',
          dictBizCode: 'china_code',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.birthCountry'),
          field: 'birthCountry',
          dicName: 'birthCountryName',
          type: 'select',
          dictCode: 'nationality',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.birthCity'),
          field: 'birthCity',
          dicName: 'birthCityName',
          type: 'select',
          dictCode: 'city',
          dictQuery: {
            code: this.data.birthCountry,
          },
          disabled: !this.data.birthCountry,
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('label.birthCountry'),
          onlyShow: this.detailType === 'view',
        },
        {
          // label: this.i18n('label.birthCountry'),
          label: 'CN Birth City',
          field: 'cnBirthCity',
          // onlyShow: this.detailType === 'view',
          onlyShow: true,
        },
        {
          label: this.i18n('label.healthStatus'),
          field: 'healthStatus',
          type: 'select',
          dictBizCode: 'health_status',
          dicName: 'healthStatusName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.accessCode'),
          field: 'accessCode',
          type: 'select',
          dictBizCode: 'access_code',
          dicName: 'accessCodeName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.traceApp'),
          field: 'traceApp',
          type: 'select',
          dictBizCode: 'trace_app',
          dicName: 'traceAppName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.nation'),
          field: 'nation',
          type: 'select',
          dictBizCode: 'worker_nation_category',
          dicName: 'nationName',
          onlyShow: this.detailType === 'view',
        },
        {
          label: this.i18n('label.dietType'),
          field: 'dietType',
          dicName: 'dietTypeName',
          onlyShow: true,
        },
        {
          label: this.i18n('label.dietCategory'),
          field: 'dietCategory',
          dicName: 'dietCategoryName',
          onlyShow: true,
        },
        {
          label: this.i18n('labelEmployment.jobTitle'),
          field: 'title',
          type: 'select',
          dictBizCode: 'jobTitle',
          onlyShow: this.detailType === 'view',
        },
      ]
      return userInfoList
    },
    form() {
      const res = this.data
      const cols = [this.userColsTop, this.userColsBottom]
      for (let i = 0; i < cols.length; i += 1) {
        const element = cols[i]
        element.forEach((item) => {
          const val = res[item.field]
          if (val || val === 0) {
            const formatVal =
              this.hasToStringTypes.indexOf(item.type) !== -1
                ? String(val)
                : val
            res[item.field] = formatVal
          }
        })
      }
      res.age = res.birthday ? getAge(res.birthday.split('-')) : ''
      return res
    },
  },
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      this.loading = true
      this.form.mobileCode = ''
      this.userData = deepClone(this.form)
      this.userDataCopy = deepClone(this.form)
      this.loading = false
    },
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    extractPhoneNumber(str) {
      // 去除字符串首尾可能存在的空格
      str = str.trim()
      let plusSignRemoved = str
      // 如果字符串以 '+' 开头，去除 '+'
      if (str.startsWith('+')) {
        plusSignRemoved = str.slice(1)
      }
      // 正则匹配区号和手机号，假设区号和手机号都是数字，以空格分隔
      const match = plusSignRemoved.match(/^(\d+)\s+(\d+)$/)
      if (match) {
        return {
          areaCode: '+' + match[1],
          phoneNumber: match[2],
        }
      }
      // 如果没有匹配到区号和手机号的格式，直接返回手机号
      return {
        areaCode: '',
        phoneNumber: str,
      }
    },
    changeEdit(e) {
      console.log('sssss', e)
      if (e === 'mobile') {
        console.log(this.userDataCopy)
        console.log(this.extractPhoneNumber(this.userDataCopy.mobile))
        const mobileObj = this.extractPhoneNumber(this.userDataCopy.mobile)
        this.userData.mobile = mobileObj.phoneNumber
        this.userData.mobileCode = mobileObj.areaCode
        console.log(this.userData, 'this.userData')
      }
    },
    updatePhoto(e) {
      const params = {
        id: this.form.id,
        photo: e.length ? e.map((o) => o.attachId).join() : -1,
      }
      WORKER.updateBaseInfo(params, { key: 'photo' }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    setValue(col) {
      console.log('sss', col)
      if (
        col.type === 'date' &&
        this.userData[col.dicName ? col.dicName : col.field]
      ) {
        return moment(
          this.userData[col.dicName ? col.dicName : col.field]
        ).format('DD MMM YYYY')
      }
      return this.userData[col.dicName ? col.dicName : col.field] || ''
    },
    update(done, value, key) {
      console.log(value, key)
      console.log(this.userDataCopy)
      this.$refs[`simpleRules${key}`][0].validate().then((success) => {
        if (success) {
          console.log(this.userData, 'sssthis.form')
          const params = { id: this.form.id }
          params[key] = value || ''
          if (
            (this.userDataCopy.status == 1 && value == 2 && key === 'status') ||
            (this.userDataCopy.status == 2 && value == 1 && key === 'status')
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: 'Cannot change to this status',
                variant: 'danger',
              },
            })
            return
          }
          if (this.userData.mobileCode && key === 'mobile') {
            params[key] = `${this.userData.mobileCode} ${this.userData.mobile}`
          }
          WORKER.updateBaseInfo(params, { key }).then((res) => {
            let isDone = false
            const refreshDone = () => {
              if (!isDone) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
                done()
                this.onLoad()
                isDone = true
              }
            }
            this.refreshChange(refreshDone)
            // this.$emit('submit', this.form)
          })
        }
      })
      done()
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    clearFormItem(key) {
      // if (key === 'mobile') {
      //   this.userData[key] = deepClone(this.userDataCopy)[key]
      // }
      // this.userData = deepClone(this.userDataCopy)
      console.log('aaaaaaaa')
      this.userData[key] = deepClone(this.userDataCopy)[key]
    },
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
  },
}
</script>

<style></style>
